<template>
  <div class="container-fluid">
    <b-row>
      <b-col class="col">

      </b-col>
    </b-row>

    <b-row style="margin-top: 15px">
      <b-col cols="7" class="tabla-problemas">
        <!--<b-card header="Banco de Problemas"
                border-variant="light">-->
        <b-row>
          <b-col md="6" style="padding-top: 3%">
           <!-- <h3 class="text-uppercase font-weight-bold" style="padding-top: 5%">Banco de Problemas</h3>-->
          </b-col>
          <b-col md="6" style="padding-top: 4%">
            <!--<b-form-group style="background-color: rgb(228, 231, 234); border-radius: 23px">
              <b-input-group>
                <b-form-input id="elementsPrependAppend" type="text" v-model="filter" placeholder="" class="buscar"
                              style="background-color: rgb(241, 242, 243);border-color: transparent"></b-form-input>
                <b-input-group-append>
                  <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" class="buscar"><i
                    class="fa fa-search"
                    style="font-size: 24px;color: #1E3375"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>-->
            <!--<b-form-group horizontal label="" class="mb-0" style="padding-top: 3%">
              <b-input-group>
                <b-form-input v-model="filter" placeholder=""/>
                <b-input-group-append>
                  <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" ><i class="fa fa-search"
                                                                                                   style="font-size: 24px;color: #D5D9DE"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>-->
          </b-col>
        </b-row>


        <b-row>
          <b-table :items="problemas"
                   :fields="fields"
                   :current-page="currentPage"
                   :per-page="perPage"
                   :filter="filter"
                   @filtered="onFiltered" style="color:#1E3375; max-width: 98%; margin-left: 10px;">
            <template slot="show_details" slot-scope="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <b-button size="sm" @click.stop="row.toggleDetails" variant="light" class="btn btn-pill mr-2">
               <!-- <i :class="[row.detailsShowing ? fa fa-caret-down:fa fa-caret-down, font-2xl text-gray-400]"></i>-->
                {{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}}
              </b-button>
              <!-- In some circumstances you may need to use @click.native.stop instead -->
              <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row class="mb-2">
                  <!--<b-col sm="3" class="text-sm-right"><b></b></b-col>-->
                  <b-col>{{ row.item.problema }}</b-col>
                </b-row>
                <!--<b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Is Active:</b></b-col>
                  <b-col>{{ row.item.isActive }}</b-col>
                </b-row>-->
                <!--<b-button size="sm" @click="row.toggleDetails" class="btn btn-pill btn-block btn-warning">Ocultar Problema</b-button>-->
              </b-card>
            </template>
          </b-table>
        </b-row>
        <b-row>
          <b-col class="my-1">
            <b-pagination align="center" :total-rows="totalRows" :per-page="perPage"
                          :hide-goto-end-buttons="true"
                          prev-text='<i class="fa fa-caret-left" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                          next-text='<i class="fa fa-caret-right" style="font-size:xx-large!important;color:#D5D9DE"></i>'
                          v-model="currentPage" class="pagination"/>
          </b-col>
        </b-row>
        <!--   </b-card>-->
      </b-col>


      <b-col cols="4" offset-md="1" style="background-color: #F7F7F9" class="selector-problemas">

        <div class="pt-4">
          <b-form-group style="background-color: rgb(228, 231, 234); border-radius: 23px">
            <b-input-group>
              <b-form-input id="elementsPrependAppend" type="text" v-model="filter" placeholder="Buscar" class="buscar"
                            style="background-color: rgb(241, 242, 243);border-color: transparent"></b-form-input>
              <b-input-group-append>
                <b-btn type="button" variant="light" :disabled="!filter" @click="filter = ''" class="buscar"><i
                  class="fa fa-search"
                  style="font-size: 24px;color: #1E3375"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>

        <div role="tablist">
          <b-card no-body class="mb-1" style="background-color: #F7F7F9">
            <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9" class="selector-header">
              <b-btn block href="#" v-b-toggle.dimension variant="light"
                     class="text-left text-uppercase font-weight-bold selector-dimensiones"
                     style="color: #1E3375;background-color: #F7F7F9">
                <i class="fa fa-caret-down font-3xl text-gray-400"></i><span>Dimensiones</span>
              </b-btn>
            </b-card-header>
            <b-collapse id="dimension" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-list-group>
                  <b-list-group-item button v-for="value in this.dimensionesVista" :key="value.id"
                                     class="d-flex justify-content-between align-items-center btn-pill listado"
                                     @click="filter = value.titulo" id="listado">
                    <span class="dimension">{{value. titulo}}</span>
                    <b-badge variant="light" pill class="lista-badge" id="badge">{{value.count}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div role="tablist">
          <b-card no-body class="mb-1" style="background-color: #F7F7F9">
            <b-card-header header-tag="header" role="tab" style="background-color: #F7F7F9">
              <b-btn block href="#" v-b-toggle.linea variant="light" class="text-left text-uppercase font-weight-bold"
                     style="color: #1E3375;background-color: #F7F7F9">
                <i class="fa fa-caret-down font-3xl text-gray-400"></i><span>Línea de investigación</span>
              </b-btn>
            </b-card-header>
            <b-collapse id="linea" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-list-group>
                  <b-list-group-item button v-for="value in this.lineasVista" :key="value.id"
                                     class="d-flex justify-content-between align-items-center btn-pill listado"
                                     @click="filter = value.titulo" id="listado">
                    {{value.titulo}}
                    <b-badge variant="light" pill class="lista-badge" id="badge">{{value.count}}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

      </b-col>
    </b-row>
  </div>
</template>

<script>
  import BarExample from '../charts/BarExample'
  import {mapActions, mapGetters} from 'vuex'
  import BarProblemas from '../graficas/problemas/barProblemas'
  import {Badge} from 'bootstrap-vue/es/components'
  import VueFilter from 'vue-filter'
  import Vue from 'vue'

  function capitalize(s){
    return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
  };

  Vue.use(VueFilter)

  export default {
    name: 'full',
    components: {
      BarProblemas,
      BarExample,
      Badge,
      VueFilter
    },
    data() {
      return {
        slide: 0,
        sliding: null,
        problemasData: [],
        fields: {
          dimension: {sortable: true,
            formatter: value => {
              return capitalize(value)
            }},
          linea: {label: 'Línea de investigación', sortable: true},
          procedencia: {label: 'Alcance', sortable: true},
          show_details: {label: 'Problema'},
        },
        items: [],
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        filter: null,
        ceroBadge: false
      }
    },
    methods: {
      ...mapActions(['getDimensiones', 'getProblemas', 'getLineas']),
      onSlideStart(slide) {
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.sliding = false
      },
      getRandomInt() {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      random_bg_color() {
        let red = Math.floor(Math.random() * 256);
        let green = Math.floor(Math.random() * 256);
        let blue = Math.floor(Math.random() * 256);
        return `rgb(${red}, ${green}, ${blue})`;
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      selectDimension(value) {
        console.log("pulsado: " + value.titulo)
        this.filter = this.dimensiones.filter(element => element.titulo == value.titulo)
        console.log(this.filter)
        this.totalRows = this.filter.length
        this.currentPage = 1
      },
      contarDimensiones(titulo) {
        let count = this.problemas.filter(problema => problema.dimension === titulo).length
        this.ceroBadge = (parseInt(count) === 0) ? 'secondary' : 'primary'
        return count
      }
    },
    created() {
      this.getDimensiones()
      this.getProblemas()
      this.getLineas()
      this.labels = this.dimensiones
      this.items = this.$store.state.problemas.problemas
      //this.totalRows = this.problemas.length
      /*this.problemasData = {
        labels: this.dimensiones.map(x => x.titulo),
        datasets: [
          {
            //label: 'GitHub Commits',
            backgroundColor: '#f87979',
            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
          }
        ],
      }*/
    },
    computed: {
      ...mapGetters(['dimensiones', 'problemas', 'countProblemas', 'lineas']),
      totalRows() {
        return this.countProblemas
      },
      dimensionesVista() {
        return this.dimensiones.map(dim => {
          dim['titulo'] = dim.titulo
          dim['count'] = this.problemas.filter(problema => problema.dimension === dim.titulo).length
          return dim
        }).filter(element => element.count > 0)
      },
      lineasVista() {
        return this.lineas.map(lin => {
          lin['titulo'] = lin.titulo
          lin['count'] = this.problemas.filter(problema => problema.linea === lin.titulo).length
          return lin
        }).filter(element => element.count > 0)
      },
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched
      },
    }
  }
</script>
<style>
  .badge {
    border-radius: 10rem;
    padding-right: .6em;
    padding-left: .6em;
    margin-left: 2px;
  }

  h3 {
    color: #1E3375;
  }

  .dimension{
    text-transform: lowercase !important;
  }
  .dimension:first-letter{
    text-transform: capitalize !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/frontend/BancoProblemas.vue